module.exports = __webpack_public_path__ + "static/media/Invert.670f2866.svg";